import { ControlProps } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";

export function ListStringConcatControl(props: ControlProps) {
  if (!props.visible) {
    return null;
  }

  // if data is not a list, return null
  if (!Array.isArray(props.data)) return null;

  // if list is not of strings, return null
  if (props.data.length === 0) return null;
  if (typeof props.data[0] !== "string") return null;

  const data = props.data.join(", ");

  return <>{data}</>;
}

export const ListStringConcatControlRenderer = withJsonFormsControlProps(
  ListStringConcatControl
);
